var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"serial_header_wrapper"}},[_c('div',{staticClass:"serial-header-col"},[_c('div',{attrs:{"id":"serial_campaign_img"}},[_c('img',{attrs:{"src":_vm.serialModel.campaignImgUrl}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }